import axios from 'axios'
import store from '@/store'

// 创建axios实例
const service = axios.create({
    baseURL: process.env.NODE_ENV === 'production' ? 'http://www.aiata.cn' : 'http://127.0.0.1:9000', // api 的 base_url
    timeout: 10000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
    config => {
        if (store.getters.token) {
            config.headers.Authorization = 'Token ' + store.getters.token // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        return config
    },
    error => {
        // Do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response 拦截器
service.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        if (error.response) {
            if (error.response.status === 401) {
                store.dispatch('ShowSnackbar', {text: '请重新登录。', timeout: 0, action: 'login'})
            } else if (error.response.status === 546) {
                // 业务逻辑错误，不在此处理
            } else {
                store.dispatch('ShowSnackbar', {text: error.response.data.error, timeout: 0, action: 'refresh'})
            }
        }
        // store.dispatch('ShowSnackbar', {text: '网络错误，检查网络。', timeout: 0, action: 'refresh'})
        return Promise.reject(error)
    }
)

export default service
